import { environment } from './../../../../environments/environment';
import { Observable } from 'rxjs';
import { Micromedidor, MicromedidorUltimaTransmision } from './../../../_entities/micromedidores/micromedidor';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class MicromedidoresService {

	constructor(private http: HttpClient) { }

	obtenerMicromedidores(): Observable<Micromedidor[]> {
		return this.http.get<Micromedidor[]>(environment.API_SECURITY + '/api/Micromedidores');
	}

	obtenerMicromedidorId(idMicromedidor: Number): Observable<Micromedidor> {
		return this.http.get<Micromedidor>(environment.API_SECURITY + '/api/Micromedidores/' + idMicromedidor);
	}

	obtenerMicromedidoresUltimaTransmision(): Observable<MicromedidorUltimaTransmision[]> {
		return this.http.get<MicromedidorUltimaTransmision[]>(environment.API_SECURITY + '/api/Micromedidores/Lecturas');
	}

	obtenerHistoricoMediciones(numeroSerie, fechaInicio, fechaFin): Observable<Micromedidor[]> {
		return this.http.get<Micromedidor[]>(environment.API_SECURITY + `/api/Micromedidores/Historico/${numeroSerie}/${fechaInicio}/${fechaFin}`);
	}


}
